import React, { useState } from 'react';
import Img from 'react-image';
import { openModal } from '@redq/reuse-modal';
import { DELETE_POST, BOOST_POST } from '@core/ui/graphql/Mutations';
import { ADD_POST } from '@core/ui/navigation/constant';
import {
  Image,
  ImageWrapper,
} from '../../../components/UserInfoBox/userInfoBox.style';
import { CURRENCY } from '../../../Config';
import { useAuth } from '../../../contexts/AuthProvider';
import { useUser } from '../../../contexts/UserContext';
import { Counter } from '../../../helpers/Counter';
import { slugify } from '../../../helpers/urlHandler';
import LoginModal from '../../ModalContainer/LoginModal';
import MessageModal from '../../ModalContainer/MessageModal';
import ContactInfoModal from '../../ModalContainer/ContactInfoModal';
import { useMutation, useQuery } from '@apollo/client';
import Icon from 'react-icons-kit';
import { pencil } from 'react-icons-kit/iconic/pencil';
import { chevronsUp } from 'react-icons-kit/feather/chevronsUp';
import { androidDelete } from 'react-icons-kit/ionicons/androidDelete';
import Button from 'reusecore/src/elements/Button';
import {
  ContactWrapper,
  AdsRightSectionWrapper,
  CenterWrapper,
} from './contact.style';
import { GET_AUTHOR_INFO } from '@core/ui/graphql/Profile.query';
import { analytics, db } from '../../../helpers/firebaseHelper';
import { SpinnerLoader } from '../../../components/Loader/spinnerLoader';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { ROLE_ADMIN } from '@core/ui/role/const';
import { confirmAlert } from 'react-confirm-alert';
import { LabelTag, TagGroup } from '../../../components/TagGroup';
import icoPhone from '@core/ui/static/images/ico-tel.svg';
import icoChat from '@core/ui/static/images/ico-chat.svg';
import BoostModal from '../../ModalContainer/BoostModal';
import { useTranslation } from 'next-i18next';
import ShareModal from '../../ModalContainer/ShareModal';
import shareIcon from '@core/ui/static/images/ico-share.svg';
import SkazyAdvertising from '../../../components/SkazyAdvertising';
import Box from 'reusecore/src/elements/Box';
import AvatarInitials from '../../../components/Avatar';
import { MdVerified } from 'react-icons/md';

const Contact = ({ postData }) => {
  const { t } = useTranslation();
  const router = useRouter();

  const { isLoggedIn } = useAuth();
  const { state: userState } = useUser();
  const { avatar, userId, userName } = userState || {};

  const [handlerMsgLoading, setHandlerMsgLoading] = useState(false);
  const [boostLoader, setBoostLoader] = useState(false);

  const { data } = useQuery(GET_AUTHOR_INFO, {
    variables: { USERNAME: userId },
    skip: isLoggedIn && userId,
  });

  let { author: authorData } = data || {};

  const contactNumber = postData && postData.mobile ? postData.mobile : '';

  const canEdit = () => {
    return (
      isLoggedIn &&
      postData.userId &&
      userId === postData.userId &&
      !postData.deleted
    );
  };

  const handleMessage = async () => {
    if (isLoggedIn) {
      setHandlerMsgLoading(true);
      db.collection('messages')
        .where('ads', '==', postData.id)
        .where('advertiser', '==', postData.userId)
        .where('sender', '==', userId)
        .limit(1)
        .get()
        .then(snapshot => {
          if (snapshot.empty) {
            db.collection('messages')
              .add({
                ads: postData.id,
                adsTitle: postData.title,
                hasLast: false,
                showing: { [userId]: true, [postData.userId]: true },
                adsImage:
                  postData.media.length > 0
                    ? postData.media[0]
                    : 'https://yatoo-nc.firebaseapp.com/images/logo.png',
                advertiser: postData.userId,
                sender: userId,
                senderName: userName,
              })
              .then(function(docRef) {
                setHandlerMsgLoading(false);
                openModal({
                  config: {
                    className: 'contactModal',
                    width: 'auto',
                    height: 'auto',
                    enableResizing: false,
                    disableDragging: true,
                    transition: {
                      tension: 150,
                    },
                  },
                  closeOnClickOutside: true,
                  component: MessageModal,
                  componentProps: {
                    advertiser: postData.userId,
                    msgActive: docRef.id,
                    userId: userId,
                    sender: userId,
                    userName: userName,
                    avatar: avatar,
                    first: true,
                    postId: postData.id,
                  },
                });
              });
          } else {
            setHandlerMsgLoading(false);
            openModal({
              config: {
                className: 'contactModal',
                width: 'auto',
                height: 'auto',
                enableResizing: false,
                disableDragging: true,
                animationFrom: { transform: 'scale(1)' },
                animationTo: { transform: 'scale(1)' },
                transition: {
                  tension: 150,
                },
              },
              closeOnClickOutside: true,
              component: MessageModal,
              componentProps: {
                advertiser: postData.userId,
                msgActive: snapshot.docs[0].id,
                userId: userId,
                sender: userId,
                userName: userName,
                avatar: avatar,
                first: !snapshot.docs[0].data().hasOwnProperty('last'),
                postId: postData.id,
              },
            });
          }
        });
    } else {
      showLoginModal();
    }
  };

  const canDelete = () => {
    if (postData.deleted) {
      return false;
    }
    return (
      isLoggedIn &&
      ((postData.userId && userId === postData.userId) || isAdmin())
    );
  };

  const boostItem = async () => {
    if (isLoggedIn) {
      // check if user can boost the ad
      const boostLimit = userState.certified === true ? 5 : 3;
      if (userState.boost >= boostLimit) {
        openModal({
          config: {
            className: 'boostModal',
            width: 'auto',
            height: 'auto',
            enableResizing: false,
            disableDragging: true,
            transition: {
              tension: 150,
            },
          },
          closeOnClickOutside: true,
          component: BoostModal,
          componentProps: {
            data: {
              success: false,
              message: 'adsView.sidebar.boost.modal.suberror',
              data: {
                boostLimit,
              },
            },
          },
        });
        return;
      }

      setBoostLoader(true);
      const { data } = await handleBoostMutation();
      const res = data.boostPost;

      if (res.success && typeof window !== 'undefined' && analytics) {
        analytics.logEvent('boost_ad', {
          currency: CURRENCY,
          items: [
            {
              id: postData.sid,
              name: postData.title,
              category: postData.category,
              price: postData.price,
            },
          ],
          value: postData.price,
        });
      }

      openModal({
        config: {
          className: 'boostModal',
          width: 'auto',
          height: 'auto',
          enableResizing: false,
          disableDragging: true,
          transition: {
            tension: 150,
          },
        },
        closeOnClickOutside: true,
        component: BoostModal,
        componentProps: {
          data: res,
        },
      });
      setBoostLoader(false);
    }
  };

  const isAdmin = () => !!(userState && userState.role === ROLE_ADMIN);

  const deleteItem = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui-delete-modal">
            <h3>{t('adsView.sidebar.delete.modal.title')}</h3>
            <p>{t('adsView.sidebar.delete.modal.msg')}</p>
            <button onClick={onClose}>{t('No')}</button>
            <button
              onClick={() => {
                handleClickDelete();
                onClose();
              }}
            >
              {t('adsView.sidebar.delete.modal.confirm')}
            </button>
          </div>
        );
      },
    });
  };

  const handleCall = () => {
    if (isLoggedIn) {
      openModal({
        config: {
          className: 'contactModal',
          width: 'auto',
          height: 'auto',
          enableResizing: false,
          disableDragging: true,
          transition: {
            tension: 150,
          },
        },
        closeOnClickOutside: true,
        component: ContactInfoModal,
        componentProps: {
          data: {
            contactNumber: contactNumber,
          },
        },
      });
      // Initialize the sharded counter.
      const telephones = new Counter(
        db.collection('ads').doc(postData.id),
        'stats.telephones'
      );

      // Increment the field "telephones" of the document
      telephones.incrementBy(1);
    } else {
      showLoginModal();
    }
  };

  const [handleBoostMutation] = useMutation(BOOST_POST, {
    variables: {
      postId: postData.id,
    },
  });

  const [handleDeleteMutation] = useMutation(DELETE_POST, {
    variables: {
      deletepost: {
        id: userId,
        postId: postData.id,
        sid: postData.sid,
      },
    },
  });

  const handleClickDelete = async () => {
    if (isLoggedIn) {
      await handleDeleteMutation();

      await router.push('/profile/myClassifieds', '/profile/myClassifieds');
    }
  };

  const handleShare = async () => {
    let isMobile = false;
    if (window.matchMedia('(any-hover: none)').matches) {
      // do sth
      isMobile = true;
    }

    // try to use
    if (isMobile && (navigator.canShare || navigator.share)) {
      try {
        const canonical = document.querySelector('link[rel=canonical]');
        await navigator
          .share({
            title: postData.title,
            text: postData.description,
            url: canonical ? canonical.href : document.location.href,
          })
          .then(() => {
            console.log('Shared successfully');
          })
          .catch(error => {
            console.error('error caught during sharing => ', error);
          });
      } catch (error) {
        // error or cancel
      }
      return;
    }

    openModal({
      config: {
        className: 'shareModal',
        width: 'auto',
        height: 'auto',
        enableResizing: false,
        disableDragging: true,
        transition: {
          tension: 150,
        },
      },
      withRnd: false,
      closeOnClickOutside: true,
      component: ShareModal,
      componentProps: {
        data: {
          image:
            postData.media && postData.media.length > 0
              ? postData.media[0]
              : '',
          price: postData.price,
          link: process.browser ? window.location.href : null,
          title: postData.title,
        },
      },
    });
  };

  const showLoginModal = () =>
    openModal({
      config: {
        disableDragging: false,
        minHeight: 'auto',
        width: 'auto',
        height: 'auto',
        enableResizing: true,
        transition: {
          tension: 150,
        },
      },
      springStyle: {
        backgroundColor: '#ffffff',
        overflowY: 'auto',
      },
      modalClass: 'loginModal',
      closeOnClickOutside: true,
      component: LoginModal,
      componentProps: {},
    });

  const showAlternateName = () => {
    const {
      additionalType = '',
      alternateName = '',
      postAuthor = '',
      userImage,
      userId: authId,
    } = postData;

    if (alternateName !== '') {
      let img = additionalType === 'pro' ? userImage : postAuthor.imageProfil;

      let alt = alternateName;

      const userSid = authId.slice(0, 8);
      alt = (
        <Link
          href={
            '/' +
            (additionalType === 'pro' ? 'pro' : 'utilisateur') +
            '/' +
            slugify(alternateName) +
            '-' +
            (additionalType === 'pro' ? slugify(userSid) : authId)
          }
        >
          <a
            style={{
              alignItems: 'center',
              color: '#155876',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {img != null ? (
              <ImageWrapper
                imgWidth={112}
                imgHeight={112}
                imgRadius={85}
                style={{ marginBottom: 10 }}
              >
                <Image src={img} alt="image" width="112px" height="112px" />
              </ImageWrapper>
            ) : (
              <>
                <Box>
                  <AvatarInitials
                    customStyle={{
                      height: 112,
                      width: 112,
                      marginBottom: 10,
                    }}
                    customSpanStyle={{
                      fontSize: 35,
                    }}
                    user={postAuthor}
                  />
                </Box>
              </>
            )}
            <h2
              style={{
                marginTop: 0,
                marginBottom: 10,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {alternateName}
              {postAuthor.certified && (
                <MdVerified
                  size={20}
                  style={{ color: '#00BCD4', marginLeft: 5 }}
                />
              )}
            </h2>
          </a>
        </Link>
      );

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {alt}
          <hr
            size={1}
            width="100%"
            color="#EEEEF1"
            style={{ marginTop: 0, marginBottom: 20 }}
          />
        </div>
      );
    }

    return null;
  };

  const getZone = () => {
    if (postData.price > 300000 && process.env.SKAZY_AD_ADS_RIGHT_ID_EXTRA) {
      return {
        id: process.env.SKAZY_AD_ADS_RIGHT_ID_EXTRA,
        n: process.env.SKAZY_AD_ADS_RIGHT_N_EXTRA,
      };
    }
    return {
      id: process.env.SKAZY_AD_ADS_RIGHT_ID,
      n: process.env.SKAZY_AD_ADS_RIGHT_N,
    };
  };

  return (
    <AdsRightSectionWrapper>
      <ContactWrapper>
        {!postData.deleted ? (
          <div>
            {showAlternateName()}
            {postData.mobile && userId !== postData.userId && (
              <Button
                iconPosition="left"
                title={t('adsView.sidebar.phone.title')}
                fontSize={12}
                className="primary"
                bg="#00BCD4"
                style={{
                  marginBottom: 15,
                  width: '100%',
                  marginRight: 10,
                  padding: 15,
                  fontSize: 15,
                  fontWeight: 'bold',
                }}
                icon={
                  <img
                    src={icoPhone}
                    alt={t('adsView.sidebar.phone.title')}
                    style={{ marginRight: '10px', marginTop: -2 }}
                  />
                }
                onClick={handleCall}
              />
            )}
            {userId !== postData.userId && (
              <Button
                iconPosition="left"
                title={t('adsView.sidebar.contact.action')}
                fontSize={12}
                className="primary"
                bg="#155876"
                onClick={handleMessage}
                style={{
                  fontSize: 15,
                  marginBottom: 15,
                  width: '100%',
                  padding: 15,
                  fontWeight: 'bold',
                }}
                icon={
                  handlerMsgLoading ? (
                    <SpinnerLoader
                      color={'white'}
                      width="30px"
                      height="30px"
                      margin="0px"
                    />
                  ) : (
                    <img
                      src={icoChat}
                      alt={t('adsView.sidebar.contact.action')}
                      style={{ marginRight: '10px' }}
                    />
                  )
                }
              />
            )}
            {canEdit() && (
              <Button
                iconPosition="left"
                title={t('update')}
                fontSize={12}
                style={{
                  fontSize: 15,
                  marginBottom: 15,
                  width: '100%',
                  padding: 15,
                  fontWeight: 'bold',
                }}
                icon={
                  <Icon
                    icon={pencil}
                    size={18}
                    color="#fff"
                    style={{ marginRight: '10px' }}
                  />
                }
                onClick={() => router.push(`/${ADD_POST}/${postData.sid}`)}
              />
            )}
            {canEdit() && (
              <Button
                iconPosition="left"
                title={t('adsView.sidebar.boost.action')}
                fontSize={12}
                disabled={boostLoader}
                style={{
                  fontSize: 15,
                  marginBottom: 15,
                  width: '100%',
                  padding: 15,
                  fontWeight: 'bold',
                  backgroundColor: '#0a2e3e',
                }}
                icon={
                  boostLoader ? (
                    <SpinnerLoader
                      color={'white'}
                      width="25px"
                      height="25px"
                      margin="0px 10px 0 0"
                    />
                  ) : (
                    <Icon
                      icon={chevronsUp}
                      size={25}
                      color="#fff"
                      style={{ marginRight: '10px' }}
                    />
                  )
                }
                onClick={boostItem}
              />
            )}
            <Button
              title={t('adsView.view.share.title')}
              variant="outlined"
              iconPosition="left"
              icon={
                <Img
                  src={shareIcon}
                  style={{ marginRight: '10px', height: 15, marginTop: '-2px' }}
                  alt=""
                />
              }
              height={40}
              className="outlineButton"
              style={{
                color: '#00BCD4',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#e2e2e2',
                height: 'auto',
                padding: '15px',
                width: '100%',
              }}
              onClick={handleShare}
            />
            {canDelete() && (
              <Button
                iconPosition="left"
                fontSize={16}
                title={t('adsView.sidebar.delete.action')}
                bg="transparent"
                style={{
                  fontSize: 14,
                  color: '#ff7676',
                  width: '100%',
                  padding: 15,
                  fontWeight: 'bold',
                }}
                icon={
                  <Icon
                    size={18}
                    style={{ marginTop: -3, marginRight: 5 }}
                    color="#fff"
                    icon={androidDelete}
                  />
                }
                onClick={deleteItem}
              />
            )}
            {isAdmin() && (
              <span
                style={{
                  display: 'flex',
                  fontSize: 12,
                  marginTop: 5,
                  color: 'gray',
                  justifyContent: 'flex-end',
                }}
              >
                {postData.userName}
              </span>
            )}
          </div>
        ) : (
          postData.deleted && (
            <TagGroup
              style={{
                border: '1px solid #ff7676',
                padding: '10px 15px',
                textAlign: 'center',
              }}
            >
              <LabelTag
                tagContent={t('adsView.sidebar.deleted')}
                style={{ color: '#ff7676', fontSize: 22, margin: '0 auto' }}
              />
            </TagGroup>
          )
        )}
      </ContactWrapper>
      {postData.category !== 'Voitures' && postData.price < 700000 && (
        <CenterWrapper>
          <SkazyAdvertising
            name="classified"
            zone={getZone()}
            height={250}
            width={300}
          />
        </CenterWrapper>
      )}
    </AdsRightSectionWrapper>
  );
};

export default Contact;
